
import { Constants } from "../utils/constants";
import { api } from "./api";
import { GuestApiAuthenticated } from "./GuestApiAuthenticated";


export const uploadAttachment = async (file, setFile, cancelToken) => {
   

let uploadPayload={
    headers: {
        "content-type": "multipart/form-data"
    },
    cancelToken: cancelToken.token,
    onUploadProgress: ({ loaded, total }) => {
        const progress = (loaded / total) * 100;
       
        setFile((prevState) => ({
            isUploading: true,
            isUploaded: false,
            progress: progress,
            url: prevState.url
        }));
    }
};
  return GuestApiAuthenticated.post(Constants.URL.upload, file,uploadPayload)
    .then(response => {
    
        return response;
    })
    .catch(error => {
        console.error("File upload failed.", error);
        return Promise.reject(error);
    });



    
};
